import React, { useState, useCallback } from "react";
import {
  BaseEdge,
  EdgeLabelRenderer,
  EdgeProps,
  getBezierPath,
  useReactFlow,
} from "reactflow";

import "./customEdge.css";

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
}) {
  const [isHover, setIsHover] = useState(false);
  const reactFlow = useReactFlow();

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const edgeColor = isHover ? "#157cfc" : "";

  const onEdgeClick = useCallback(
    (event, id) => {
      event.stopPropagation();
      reactFlow.setEdges((edges) => edges.filter((edge) => edge.id !== id));
    },
    [reactFlow]
  );

  return (
    <g
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        style={{ ...style, stroke: edgeColor }}
      />
      <EdgeLabelRenderer>
        <div
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            fontSize: 12,
            pointerEvents: "all",
          }}
          className="nodrag nopan"
        >
          {isHover && (
            <button
              className="edgebutton"
              onClick={(event) => onEdgeClick(event, id)}
            >
              ×
            </button>
          )}
        </div>
      </EdgeLabelRenderer>
    </g>
  );
}
